module.exports = __webpack_public_path__ + "static/media/Cabinet_Scratch_Before.07b1c6b0.jpg";